export const columnFields = [
	'state',
	'sourceOrganization',
	'targetOrganization',
	'recipes',
	'createdAt',
	'updatedAt',
	'updatedBy',
] as const;
